export const WORKBOARD_SPREADSHEET_VIRTUAL_ROW_HEIGHT = 50;
export const WORKBOARD_SPREADSHEET_DEFAULT_COLUMN_WIDTH = 150;
export const WORKBOARD_SPREADSHEET_ROW_OVERSCAN_COUNT = 8;
export const WORKBOARD_SPREADSHEET_COLUMN_OVERSCAN_COUNT = 2;
export const WORKBOARD_SPREADSHEET_SKELETON_ROW_COUNT = 12;
